<template>
  <div id="addressinfo" class="addressinfo userbox" v-loading.fullscreen="loading">
    <div class="userTitle">Shipping address</div>
    <div class="setaddressinfoBox">
      <to-address :title='title' :domVisible='dislogType.address' :list='addressItem' :isSet="isSet" @closeDialog="closeDialog" v-if="dislogType.address" />
      <div class="userSetaddressinfo" @click="setAddress('address',0)">Add shipping address</div>
    </div>
    <ul class="addressinfoList" v-if="!isNull">
      <li v-for="(item,index) in list" :key='index' :class="item.IsDefault?'on':''">
        <div class="addresst">
          <span>Company Name</span>
          <div class="addressText">{{item.CompanyName}}</div>
        </div>
        <div class="addresst">
          <span>Tax ID</span>
          <div class="addressText">{{item.TaxCode}}</div>
        </div>
        <div class="addresst">
          <span>Email Address</span>
          <div class="addressText">{{item.Email}}</div>
        </div>
        <div class="addresst">
          <span>Consignee</span>
          <div class="addressText">{{item.UserName}}</div>
        </div>
        <div class="addresst">
          <span>Phone number</span>
          <div class="addressText">{{item.Mobile}}</div>
        </div>
        <div class="addresst">
          <span>Country / Region</span>
          <div class="addressText line_txt2">{{item.Country}}</div>
        </div>
        <div class="addresst">
          <span>Street address</span>
          <div class="addressText last_text line_txt2">{{item.Provice|setProvice}} {{item.City}} {{item.AddressDetail}}  {{item.ZipCode}}</div>
        </div>
        <span class="default" v-if="item.IsDefault">Default</span>
        <span class="setAddress" @click="setAddress('address',1,item)"></span>
        <span class="defAddress" v-if="!item.IsDefault" @click="defAddress(item)">Default address</span>
        <span class="delAddress" v-if="!item.IsDefault" @click="delAddress(item)">Delete</span>
      </li>
    </ul>
    <nonull type='address' text="No saved addresses" v-if="isNull" />
  </div>
</template>
<script>
import { getInfo } from "@/api/public";
import Nonull from '@/components/nonull'
import ToAddress from '@/components/dialog/address'
export default {
  name: 'addressinfo',
  components: { ToAddress, Nonull },
  data() {
    return {
      loading: false,
      userInfo: getInfo(),
      pi: this.$enumInfo.addressPage.pageindex,
      ps: this.$enumInfo.addressPage.pagesize,
      list: null,
      addressItem: null,
      isSet: false,
      isNull: false,
      title: "",
      isAdd: 0,
      dislogType: this.$enumInfo.dislogType,
    }
  },
  filters: {
    setProvice(val){
      // var regex = /(<([^>]+)>)/ig;
      if(val!=null){
        // val=val.replace(regex,'');
        val=val.replace(/\-/g,' ');
        //val=val.replace('&nbsp;','');
      }
      return val
    }
  },
  mounted() {},
  created() {
    this.getAddress();
  },
  methods: {
    getAddress() {
      let that = this;
      that.loading = true;
      let data = { MemberId: that.userInfo._id, PageIndex: that.pi, PageSize: that.ps }
      that.$get(that.$interface.SearchShippingAddresses, data).then(res => {
        if (res.Result != 0) {
          that.list = res.Data;
          that.isNull = res.Count > 0 ? false : true;
        } else {
          that.isNull = true;
        }
        that.loading = false;
      })
    },
    defAddress(obj){
      let that = this;
      let data = {
        id: obj._id,
        memberId: that.userInfo._id
      }
      that.$post(that.$interface.SetDefaultAddress,data).then(res=>{
        if(res.Result!=0){
          that.getAddress();
        }else{
          that.$message.error(res.Msg);
        }
      })
    },
    delAddress(obj) {
      let that = this;
      let data = {
        id: obj._id,
        memberId: that.userInfo._id
      }
      that.$post(that.$interface.DeleteAddress,data).then(res=>{
        if(res.Result!=0){
          that.getAddress();
        }else{
          hat.$message.error(res.Msg);
        }
      })
    },
    setAddress(val, type, obj) {
      if (type == 1) {
        this.title = 'Edit shipping address'
        this.addressItem = JSON.parse(JSON.stringify(obj))
        console.log(this.addressItem)
      } else {
        this.title = 'Add shipping address'
      }
      this.isSet = type > 0 ? false : true;
      this.dislogType[val] = true;
    },
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
      this.getAddress()
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/user.css";

</style>



// WEBPACK FOOTER //
// src/pages/user/address.vue